export enum EBrandCategory {
  EXCLUSIVE = 'EXCLUSIVE',
  MULTIBRAND = 'MULTIBRAND',
}

export const EBrandCategoryDisplayName: { [key in EBrandCategory]: string } = {
  EXCLUSIVE: 'Exclusiva',
  MULTIBRAND: 'Multimarcas',
};
